import { styled } from '@mui/material';
import { Box, Button, Link, Stack, Text } from 'shell/components';

const EmailSentConfirmation = ({ device, form, handleResendCode }) => {
    return (
        <EmailSentBox device={device}>
            <Stack alignItems={'center'} spacing={1} sx={{ marginBottom: 6 }}>
                <Text component={'h1'} variant={'h6'} weight={'medium'}>
                    Email Sent!
                </Text>
                <Stack spacing={5}>
                    <Text variant={'p1'} align={'center'}>
                        If there is a TimelyGrader account associated with{' '}
                        <Text component={'span'} variant={'p1'} weight={'semibold'}>
                            {form.email}
                        </Text>
                        , then you will receive instructions to reset your password within 5 minutes.
                    </Text>
                    <Text variant={'p1'} align={'center'}>
                        Didn't get your email? Be sure to check your spam folders and ensure you have entered the
                        correct email address.
                    </Text>
                </Stack>
                <Stack sx={{ width: '100%', margin: (theme) => theme.spacing(6, 0, 3, 0) }}>
                    <Button
                        size={'small'}
                        variant={'borderless'}
                        sx={{ textDecoration: 'underline', width: '100%' }}
                        onClick={() => handleResendCode()}
                    >
                        Resend Email
                    </Button>
                </Stack>
                <Stack alignItems={'center'}>
                    <Text>
                        <Link to={'/'}>Return to login</Link>
                    </Text>
                </Stack>
            </Stack>
        </EmailSentBox>
    );
};

const EmailSentBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: device === 'mobile' ? 0 : theme.spacing(7),
        width: device === 'mobile' ? '100%' : 450,
        height: 'fit-content',
        background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
        boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
        borderRadius: '12px',
    };
});

export default EmailSentConfirmation;
